import React from 'react';
import AdContainer from 'src/components/ads';

const MobileTopAd: React.VFC = () => {
  return (
    <AdContainer
      placement="dubbelpanorama_top"
      min={0}
      max={860}
      format="toppanorama"
      spacing={{ top: '10px' }}
    />
  );
};

export default MobileTopAd;
